/**
 * @class
 * @extends mkE.Base
 */
T.NewsletterSignUp = Class(
	/**
	 * @lends {T.NewsletterSignUp#}
	 */
	{
		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'NewsletterSignUp',
				els: [
					this._form = mkE({
						tag: 'form',
						onsubmit: this._onSubmitForm,
						els: [
							this._inputName = new T.Form.Input({
								caption: t('business.newsletter-signup.name'),
								placeholder: t('business.newsletter-signup.name.placeholder')
							}),
							this._inputEmail = new T.Form.Input({
								caption: t('business.newsletter-signup.email'),
								placeholder: t('business.newsletter-signup.email.placeholder'),
								type: 'email',
								required: true
							}),
							{
								tag: 'div',
								className: 'button-container',
								els: [
									this._submitButton = mkE({
										tag: 'button',
										className: 'button button-pink',
										text: t('business.newsletter-signup.submit')
									})
								]
							}
						]
					})
				]
			});
			this.rpc = new RPC('/api/web_rpc.php');
		},

		_isSubmitting: false,

		_onSubmitForm(e) {
			e.preventDefault();
			if (this._isSubmitting) {
				return false;
			}
			this._submitButton.disabled = true;
			this._isSubmitting = true;
			this.rpc.send('blogSubscribe', {
				email: this._inputEmail.value(),
				name: this._inputName.value()
			}, this._onSubmitRe);
		},

		_onSubmitRe() {
			this._form.remove();
			mkE({
				tag: 'div',
				className: 'form__success',
				els: [
					{
						tag: 'div',
						className: 'h2',
						text: t('business.newsletter-signup.success.title')
					},
					{
						tag: 'p',
						text: t('business.newsletter-signup.success.p')
					}
				]
			}).append(this.node);
			D.gtag('EmailSignup', {
				ecommerce: {
					currency: 'EUR',
					value: 0,
					form_destination: window.location.href
				}
			}, {
				email: this._inputEmail.value() || null,
				firstName: this._inputName.value() || null,
			});
		}
	},
	mkE.Base
);